import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { Point2D } from "~/types/api";

type StatusState = {
  hoverPosition: Point2D | null;
  selectedAutostoreGridId?: Guid;
  selectedTaskGroupId?: number;
  taskGroupSortField: string | null;
  taskGroupSortDirection: "asc" | "desc";
};

const initialState: StatusState = {
  hoverPosition: null,
  selectedAutostoreGridId: undefined,
  selectedTaskGroupId: undefined,
  taskGroupSortField: null,
  taskGroupSortDirection: "asc"
};

export const statusSlice = createSlice({
  name: "status",
  initialState,
  reducers: {
    setStatusHoverPosition(state, { payload }: PayloadAction<Point2D | null>) {
      state.hoverPosition = payload;
    },
    setSelectedTaskGroupId(
      state,
      { payload }: PayloadAction<number | undefined>
    ) {
      state.selectedTaskGroupId = payload;
    },
    setSelectedAutostoreGridId(
      state,
      { payload }: PayloadAction<Guid | undefined>
    ) {
      state.selectedAutostoreGridId = payload;
    },
    setTaskGroupSort(
      state,
      {
        payload
      }: PayloadAction<{
        field: string | null;
        direction: "asc" | "desc";
      }>
    ) {
      state.taskGroupSortField = payload.field;
      state.taskGroupSortDirection = payload.direction;
    }
  }
});

export const {
  setSelectedAutostoreGridId,
  setStatusHoverPosition,
  setSelectedTaskGroupId,
  setTaskGroupSort
} = statusSlice.actions;

// Persist config - only persist sort preferences (not transient UI state)
const statusPersistConfig = {
  key: "status",
  storage,
  whitelist: ["taskGroupSortField", "taskGroupSortDirection"]
};

export const statusReducer = persistReducer(
  statusPersistConfig,
  statusSlice.reducer
);
